import Vue from 'vue';
import { magic } from '@gig/magic-sdk';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const STATIC_PAGES_NAMESPACE = "STATIC_PAGES_NAMESPACE";
const SET_STATIC_PAGE = "SET_STATIC_PAGE";
const SET_IS_LOADING = "SET_IS_LOADING";
const SET_CATEGORY = "SET_CATEGORY";
const getPageKey = (slug, lang) => `${lang}---${slug}`;
const staticPageGetters = {
  staticPage: (state) => (slug, lang) => {
    return state.staticPages[getPageKey(slug, lang)];
  },
  getCategory: (state) => {
    return state.category;
  },
  isLoading: (state) => (slug, lang) => {
    return state.isLoading[getPageKey(slug, lang)];
  }
};
const staticPageActions = {
  fetchStaticPage(_0, _1) {
    return __async(this, arguments, function* ({ commit, state }, { slug, lang }) {
      const key = getPageKey(slug, lang);
      if (state.staticPages[key] || state.isLoading[key]) {
        return;
      }
      commit(SET_IS_LOADING, { isLoading: true, key });
      const page = yield magic.methods.pages.get({ slug, lang });
      commit(SET_STATIC_PAGE, { page, key });
      commit(SET_IS_LOADING, { isLoading: false, key });
    });
  },
  fetchCategory(_0, _1) {
    return __async(this, arguments, function* ({ commit }, { category, lang }) {
      const fetchedCategory = yield magic.methods.pages.get({
        category,
        lang
      });
      commit(SET_CATEGORY, fetchedCategory);
      return fetchedCategory;
    });
  }
};
const staticPage = {
  namespaced: true,
  state: {
    staticPages: {},
    isLoading: {},
    category: []
  },
  getters: staticPageGetters,
  actions: staticPageActions,
  mutations: {
    [SET_STATIC_PAGE](state, { page, key }) {
      Vue.set(state.staticPages, key, page);
    },
    [SET_IS_LOADING](state, { isLoading, key }) {
      Vue.set(state.isLoading, key, isLoading);
    },
    [SET_CATEGORY](state, fetchedCategory) {
      state.category = fetchedCategory;
    }
  }
};

export { SET_CATEGORY, SET_IS_LOADING, SET_STATIC_PAGE, STATIC_PAGES_NAMESPACE, staticPage, staticPageActions, staticPageGetters };
